export default function validation(response) {
  const messages = [];
  if (!response.data.result || !response.data.result.details) {
    return messages;
  }
  const message = response.data.result.details;
  if (message.indexOf('[User locked out message]') === 0) {
    messages.push({ message: 'connexion.error.blocked' });
  }
  if (message.indexOf('Nom d\'utilisateur ou mot de passe non valide') === 0) {
    messages.push({ message: 'connexion.error.infoIncorrect' });
  }
  if (message.indexOf('Echec d\'authentification !') === 0) {
    messages.push({ message: 'connexion.error.infoIncorrect' });
  }
  if (typeof message === 'string' && message.match(/L'utilisateur .* n'est pas actif ou ne peut pas s'authentifier/g)) {
    messages.push({ message: 'connexion.error.userInactif' });
  }

  return messages;
}
